module.exports = __webpack_public_path__ + "img/254e1d44b77b7f23ae744b48eb5e13fe.7ed8c9c4.jpg";